<template>
  <li class="nav-item dropdown">
    <a
      href="#"
      class="nav-link dropdown-toggle"
      data-v-step="myAccount"
      data-toggle="dropdown"
    >
      <i class="fas fa-user mr-1"></i>{{ user.last }}, {{ user.first }}
    </a>
    <div class="dropdown-menu">
      <router-link
        :to="{ name: 'myAccount' }"
        class="dropdown-item"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        >Edit Account</router-link
      >
      <router-link
        to="/my-vendors"
        class="dropdown-item"
        data-toggle="collapse"
        data-v-step="editVendorProfile"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        >My Vendors</router-link
      >
      <div class="dropdown-divider"></div>
      <router-link
        :to="{ name: 'logout' }"
        class="dropdown-item"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        >Logout</router-link
      >
    </div>
  </li>
</template>
<script>
export default {
  name: "VendorNav",
  props: ["user"],
};
</script>
